import { Material, Mesh, Object3D } from "three";

export const updateOccluderMaterial = (object: Object3D, opacity: number) => {
  object.traverse((child) => {
    if ((child as Mesh).isMesh && (child as Mesh).material) {
      const material = (child as Mesh).material as Material;
      material.transparent = true;
      material.opacity = opacity;
      material.depthWrite = true;
      // material.colorWrite = false; // comment if you want visualize occluder
    }
  });
};

export const updateGlassesMaterial = (object: Object3D, hdrTexture: any) => {
  object.traverse((child) => {
    if ((child as Mesh).isMesh && (child as Mesh).material) {

      const material = (child as Mesh).material as any;
      material.envMap = hdrTexture;
      material.envMapIntensity = 1;
      material.depthWrite = true;
      material.depthTest = true;
      material.transparent = true;
      material.needsUpdate = true;
      const reflective = ["lens", "metal", "glass", "frame_2"];
      const containsGlass = reflective.some(substring => child.name.includes(substring));
      if (containsGlass) {
        material.roughness = 0;
        material.metalness = 0.5;
      } else {
        material.roughness = 0.4;
        material.metalness = 0;
      }
      material.clearcoat = 0;
    }
  });
};
